type FormatDateOptions = {
    withTime?: boolean
    withSeconds?: boolean
}

export default function formatDate(
    value: string | null | undefined,
    options: FormatDateOptions = { withTime: true, withSeconds: true }
): string | null {
    if (!value) return null

    let date: Date

    // ISO / Z / T formats
    if (value.includes('T')) {
        date = new Date(value)
    }
    // "YYYY-MM-DD HH:mm:ss"
    else if (value.includes(' ')) {
        date = new Date(value.replace(' ', 'T'))
    }
    // "YYYY-MM-DD"
    else {
        date = new Date(`${value}T00:00:00`)
    }

    if (isNaN(date.getTime())) return value

    const pad = (n: number) => String(n).padStart(2, '0')

    const day = pad(date.getDate())
    const month = pad(date.getMonth() + 1)
    const year = date.getFullYear()

    if (!options.withTime) {
        return `${day}.${month}.${year}`
    }

    const hours = pad(date.getHours())
    const minutes = pad(date.getMinutes())

    if (!options.withSeconds) {
        return `${day}.${month}.${year} ${hours}:${minutes}`
    }

    const seconds = pad(date.getSeconds())
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
}